module.exports = __webpack_public_path__ + "rijksoverheidsanstext-regular_2_0.woff2?76cf8018064464877fc3114a9d4985c7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/rijksoverheidsanstext-regular_2_0.woff2
// module id = 547
// module chunks = 0